export const GET_SUBMISSION = 'GET_SUBMISSION'
export const SAVE_SUBMISSION = 'SAVE_SUBMISSION';

